import CircularProgress from '@mui/material/CircularProgress';
import Button from '../Button';

const LoadingButton = ({ loading, children, ...props }) => (
  <Button {...props}>
    {
      loading ? (
        <CircularProgress color="inherit" size={16} />
      ) : children
    }
  </Button>
);

export default LoadingButton;